/* eslint-disable react-hooks/exhaustive-deps */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { trackAnnouncementEvent } from "../../../docuclipper/api";
import Megaphone from "../../../icons/refer.jpg";
import Review from "../../../icons/review.png";
import Team from "../../../icons/team.png";
import Refresh from "../../../icons/refresh.png";
import { ReduxState } from "../../../redux";
import { clearAnnouncement } from "../../../redux/reducers/Announcement";
// import { FiX } from "react-icons/fi";
import { animationKeyframes } from "./animations";
import { styles } from "./styles";
import { Button } from "react-bootstrap";

const imageKeyToImage = {
  review: Review,
  refer: Megaphone,
  team: Team,
  reloadNewVersion: Refresh,
};

export interface ComponentProps {
  /** The title of the announcement. */
  title: string;

  /** The general card text on the announcement. */
  subtitle: string;

  /**
   * The image source string used on the left side of the image.
   * Use a square image for the best results.
   * Dimensions are 68x68 pixels.
   */
  imageKey: string;

  /** The link used when the announcement is clicked. */
  externalLink: string;

  link: string;

  /**
   * An optional property specifying the number of days
   * the cookie will live before the announcement is
   * shown again to a user.
   */
  daysToLive?: number;

  /**
   * The number of seconds a user has to
   * keep the page open before the
   * announcement is shown.
   */
  secondsBeforeBannerShows?: number;

  /**
   * Change the size of the close icon shown
   * in the top right corner of the announcement.
   */
  closeIconSize?: number;

  /**
   * Change the duration of the fade-in animation (defaults to 1000ms)
   */
  animateInDuration?: number;

  /**
   * Change the duration of the fade-out animation (defaults to 300ms)
   */
  animateOutDuration?: number;

  onClick: () => void;
  onClose: () => void;
}

export const Announcement2: React.FunctionComponent<ComponentProps> = ({
  title,
  subtitle,
  imageKey,
  link,
  daysToLive,
  secondsBeforeBannerShows,
  closeIconSize,
  animateInDuration,
  animateOutDuration,
  externalLink,
  onClick,
  onClose,
}) => {
  const imageSource = imageKeyToImage[imageKey];
  // const [cookies, setCookie] = useCookies(["banner"]);
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [showAnimation, setShowAnimation] = useState<boolean>(true);

  const history = useHistory();

  const secondsBeforeBanner =
    secondsBeforeBannerShows !== undefined
      ? secondsBeforeBannerShows * 1000
      : 7000;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowBanner(true);
    }, secondsBeforeBanner);

    return () => clearTimeout(timeoutId)
  }, []);

  /**
   * Executed when the announcement
   * is clicked and opens the link
   * in a new window.
   */
  const openLink = (): void => {
    if (externalLink) {
      window.open(link, "_blank");
    } else if (link) {
      history.push(link);
    }

    onClick();

    // TODO track click
  };

  /**
   * Executes when the close icon
   * is clicked. Creates the fadeout
   * animation and hides the banner
   * from the page.
   */
  const fadeOut = (): void => {
    setShowAnimation(false);

    setTimeout(() => {
      setShowBanner(false);
    }, animateOutDuration || 300);

    onClose()
  };

  /**
   * Truncates a string when it is
   * too long to display in the component.
   * @param text
   */
  const truncate = (text: string): string => {
    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  };

  return showBanner ? (
    <>
      <style children={animationKeyframes} />
      <div
        style={{
          ...styles.bannerCard,
          ...styles.animationStyles({
            showAnimation,
            animateInDuration,
            animateOutDuration,
          }),
        }}
      >
        <img
          onClick={openLink}
          style={styles.imageStyle}
          src={imageSource}
          alt="Banner"
        />
        <div onClick={openLink} style={styles.textWrapper}>
          <h3 style={styles.titleStyle}>{title}</h3>
          <p style={styles.subtitleStyle}>{truncate(subtitle)}</p>
          {imageKey === "reloadNewVersion" && (
            <Button
              className="m-2"
              variant="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Update
            </Button>
          )}
        </div>
        {/* <FiX style={styles.closeIcon} size={closeIconSize} onClick={fadeOut} /> */}
        <FontAwesomeIcon icon="times" onClick={fadeOut} />
      </div>
    </>
  ) : null;
};

Announcement2.defaultProps = {
  daysToLive: 7,
  secondsBeforeBannerShows: 0.1,
  closeIconSize: 30,
  animateInDuration: 1000,
  animateOutDuration: 300,
} as Partial<ComponentProps>;

type Props = {};

export const Announcement: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const { announcement } = useSelector(
    (state: ReduxState) => state.Announcement
  );

  if (!announcement) {
    return null;
  }

  const onClick = () => {
    trackAnnouncementEvent({
      eventType: "click",
      announcementId: announcement.id,
    }).catch((err) => null);
  };

  const onClose = () => {
    trackAnnouncementEvent({
      eventType: "close",
      announcementId: announcement.id,
    }).catch((err) => null);

    dispatch(clearAnnouncement());
  };
  return (
    <Announcement2 {...announcement} onClick={onClick} onClose={onClose} />
  );
};

export default Announcement;
